import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';

interface GetAccountDeviceParams {
    with_current_position?: boolean;
    [key: string]: any;
}

export default (
    accountId: Ref<number> | number,
    deviceId: Ref<number> | number,
    params?: Ref<GetAccountDeviceParams> | GetAccountDeviceParams
) => {
    return useQuery({
        queryKey: [
            'account-device',
            () => unref(accountId),
            () => unref(deviceId),
            () => unref(params)
        ],
        queryFn: () => {
            const { api, baseURL } = getApi();
            const actualAccountId = unref(accountId);
            const actualDeviceId = unref(deviceId);
            const actualParams = unref(params) || {};
            
            return api.get(`/api/accounts/${actualAccountId}/devices/${actualDeviceId}`, {
                baseURL,
                params: actualParams
            }).then(res => res.data.data);
        },
        enabled: !!(unref(accountId) && unref(deviceId)),
    });
}
